import { render, staticRenderFns } from "./CmsContent.vue?vue&type=template&id=152d6fee&scoped=true"
import script from "./CmsContent.vue?vue&type=script&lang=ts"
export * from "./CmsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152d6fee",
  null
  
)

export default component.exports